import { css } from 'styled-components';

import type { ITypography, TEyebrowTypes } from '../types';

const Eyebrow = css<ITypography>`
  ${({ theme, variant }) => css`
    letter-spacing: ${theme.typography.variants[variant as TEyebrowTypes].letterSpacing};
    text-transform: ${theme.typography.variants[variant as TEyebrowTypes].textTransform};
  `}
`;

export default Eyebrow;
